var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7448 5.63366C13.0448 2.55366 10.3581 1.16699 7.99811 1.16699C7.99811 1.16699 7.99811 1.16699 7.99144 1.16699C5.63811 1.16699 2.94478 2.54699 2.24478 5.62699C1.46478 9.06699 3.57144 11.9803 5.47811 13.8137C6.18478 14.4937 7.09144 14.8337 7.99811 14.8337C8.90478 14.8337 9.81144 14.4937 10.5114 13.8137C12.4181 11.9803 14.5248 9.07366 13.7448 5.63366Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99844 8.97344C9.15824 8.97344 10.0984 8.03324 10.0984 6.87344C10.0984 5.71364 9.15824 4.77344 7.99844 4.77344C6.83864 4.77344 5.89844 5.71364 5.89844 6.87344C5.89844 8.03324 6.83864 8.97344 7.99844 8.97344Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGray);
export default __webpack_public_path__ + "static/media/location_gray.40be5b273db0459a6488fd71d67a9c87.svg";
export { ForwardRef as ReactComponent };